// Format a persona object into the short descriptive string interpolated into the chat/schedule
// system prompt's {{persona}} placeholder. Extracted from AiAnalystPage so chat and the schedule
// modals share one implementation.
// Empty sentinel for no persona — injects no role so the model doesn't assume one and asks instead.
export const DEFAULT_PERSONA = '';

// Role-free {{persona}} filler for the DB-default template when no persona is set, so the prompt
// stays grammatical without asserting a role and nudges the model to ask (see ONBOARDING STEP 1).
export const UNKNOWN_PERSONA_AUDIENCE =
  'professionals across many industries whose specific role and region are not yet known';

export function formatPersonaForPrompt(persona: any): string {
  if (!persona) return DEFAULT_PERSONA;

  let personaDesc = persona.name || 'professional';

  // Parse summary if it exists
  let summary = null;
  if (persona.summary) {
    try {
      summary = JSON.parse(persona.summary);
    } catch {
      // Ignore parse errors
    }
  }

  // Add role if available
  if (summary?.role) {
    personaDesc += ` working as ${summary.role}`;
  }

  // Add regions if available
  if (persona.regions?.length > 0) {
    personaDesc += ` working in ${persona.regions.join(' and ')}`;
  }

  // Add markets if available
  if (persona.markets?.length > 0) {
    personaDesc += ` focused on ${persona.markets.join(' and ')} markets`;
  }

  return personaDesc;
}
